// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tabs__wbkiM {
  gap: 0.25rem; }

.styles_tab__HqZWB,
.styles_activeTab__hFvGw {
  cursor: pointer; }

.styles_activeTab__hFvGw {
  color: #72abab !important; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/components/Tabs/TabsHeader/styles.module.scss"],"names":[],"mappings":"AAEA;EACI,YAAY,EAAA;;AAGhB;;EAEI,eAAe,EAAA;;AAGnB;EACI,yBAA6B,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.tabs {\n    gap: 0.25rem;\n}\n\n.tab,\n.activeTab {\n    cursor: pointer;\n}\n\n.activeTab {\n    color: $ocean_blue !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `styles_tabs__wbkiM`,
	"tab": `styles_tab__HqZWB`,
	"activeTab": `styles_activeTab__hFvGw`
};
export default ___CSS_LOADER_EXPORT___;
